import { render, staticRenderFns } from "./ReportsFilterDate.vue?vue&type=template&id=538a2143&"
import script from "./ReportsFilterDate.vue?vue&type=script&lang=js&"
export * from "./ReportsFilterDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QDate from 'quasar/src/components/date/QDate.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QDate});
